import React, { useState } from "react";

const SlotCalculator = () => {
  const [denomination, setDenomination] = useState("");
  const [paylines, setPaylines] = useState("");
  const [bankroll, setBankroll] = useState("");
  const [totalBet, setTotalBet] = useState("0.00");
  const [maxSpins, setMaxSpins] = useState(0);
  const [remainingBalance, setRemainingBalance] = useState("0.00");

  const calculate = () => {
    const denom = parseFloat(denomination) || 0;
    const lines = parseInt(paylines) || 0;
    const bank = parseFloat(bankroll) || 0;

    if (denom > 0 && lines > 0 && bank > 0) {
      const totalBetPerSpin = denom * lines;
      const spins = Math.floor(bank / totalBetPerSpin);
      const balance = bank % totalBetPerSpin;

      setTotalBet(totalBetPerSpin.toFixed(2));
      setMaxSpins(spins);
      setRemainingBalance(balance.toFixed(2));
    }
  };

  const reset = () => {
    setDenomination("");
    setPaylines("");
    setBankroll("");
    setTotalBet("0.00");
    setMaxSpins(0);
    setRemainingBalance("0.00");
  };

  return (
    <div className="max-w-md mx-auto p-6 border border-gray-300 rounded-lg bg-white shadow-md mt-10">
      <h1 className="text-2xl font-bold mb-4">Slot Denomination Calculator</h1>

      <label className="block mb-2 text-base" htmlFor="denomination">
        Denomination per Line ($):
      </label>
      <input
        type="number"
        id="denomination"
        value={denomination}
        onChange={(e) => setDenomination(e.target.value)}
        placeholder="e.g., 0.25"
        className="w-full px-4 border border-gray-300 rounded focus:outline-none"
      />

      <label className="block mt-4 mb-2 text-base" htmlFor="paylines">
        Number of Active Paylines:
      </label>
      <input
        type="number"
        id="paylines"
        value={paylines}
        onChange={(e) => setPaylines(e.target.value)}
        placeholder="e.g., 20"
        className="w-full px-4 border border-gray-300 rounded focus:outline-none"
      />

      <label className="block mt-4 mb-2 text-base" htmlFor="bankroll">
        Bankroll Amount ($):
      </label>
      <input
        type="number"
        id="bankroll"
        value={bankroll}
        onChange={(e) => setBankroll(e.target.value)}
        placeholder="e.g., 100"
        className="w-full px-4 border border-gray-300 rounded focus:outline-none"
      />

      <div className="mt-6 flex gap-4">
        <button
          onClick={calculate}
          className="w-full bg-[#1d70df] text-white font-semibold rounded hover:bg-blue-600 focus:outline-none"
        >
          Calculate
        </button>
        <button
          onClick={reset}
          className="w-full bg-gray-300 text-gray-700 font-semibold rounded hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400"
        >
          Reset
        </button>
      </div>

      <div className="text-2xl font-bold my-4">Results:</div>
      <div className="text-xl mb-2">Total Bet per Spin: ${totalBet}</div>
      <div className="text-xl mb-2">Maximum Spins: {maxSpins}</div>
      <div className="text-xl mb-2">Remaining Balance: ${remainingBalance}</div>
    </div>
  );
};

export default SlotCalculator;